import { React } from 'react';
import ServiceSection from '../../../../ServiceSection/ServiceSection';
import SatelliteText from '../../../SatelliteText/SatelliteText';
import satelliteIcon from '../../../satelliteIcon';

const InternalVsExternalSupport7 = props => (
    <ServiceSection noPadTitle singleTitle icon={satelliteIcon} {...props} page="internalVsExternalSupport" section="decide">
        <div className='TextGroup Satellite'>
            <div className='container-custom subtitle'>
                <SatelliteText t={props.t} prefix="internalVsExternalSupport:decide" first noPadBottom />
            </div>
        </div>
    </ServiceSection>
);

export default InternalVsExternalSupport7;
